import { render, staticRenderFns } from "./reviewApplyRoomDiscount.vue?vue&type=template&id=5fb3b9ec&scoped=true"
import script from "./reviewApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./reviewApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./reviewApplyRoomDiscount.vue?vue&type=style&index=0&id=5fb3b9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb3b9ec",
  null
  
)

export default component.exports